<!-- État chargement global -->
<div *ngIf="chargement" class="carte-rapport">
  <div class="chargement-mini"><i class="fal fa-spinner"></i> Chargement des données de satisfaction…</div>
</div>

<!-- État erreur -->
<div *ngIf="!chargement && erreur" class="carte-rapport">
  <div class="vide">
    <i class="fal fa-exclamation-triangle" style="color:#f59e0b"></i>
    {{ erreur }}
    <br />
    <button (click)="charger()"
            style="margin-top:14px;height:34px;padding:0 18px;background:#10b981;color:#fff;border:none;border-radius:8px;font-size:13px;font-weight:600;cursor:pointer;">
      <i class="fal fa-redo"></i> Réessayer
    </button>
  </div>
</div>

<ng-container *ngIf="!chargement && !erreur">

  <!-- ── 2.1 Note moyenne ───────────────────────────────── -->
  <div class="carte-rapport">
    <div class="carte-titre">
      <h3><i class="fal fa-star"></i> Satisfaction client</h3>
      <button (click)="charger()"
              style="height:30px;padding:0 14px;background:#f1f5f9;border:1px solid #e2e8f0;border-radius:8px;font-size:12px;color:#475569;cursor:pointer;">
        <i class="fal fa-sync-alt"></i> Actualiser
      </button>
    </div>

    <!-- Aucune donnée -->
    <div *ngIf="nbAvis === 0" class="vide">
      <i class="fal fa-star-half-alt"></i>
      Aucun avis client sur la période sélectionnée.
    </div>

    <ng-container *ngIf="nbAvis > 0">
      <div class="grille-kpi">
        <div class="kpi kpi-success">
          <div class="kpi-label">Note moyenne</div>
          <div class="kpi-valeur">{{ noteMoyenne | number:'1.1-1' }} <small style="font-size:14px;color:#94a3b8;">/ 5</small></div>
        </div>
        <div class="kpi kpi-primary">
          <div class="kpi-label">Avis reçus</div>
          <div class="kpi-valeur">{{ nbAvis }}</div>
        </div>
        <div class="kpi kpi-success">
          <div class="kpi-label">Taux de satisfaction</div>
          <div class="kpi-valeur">{{ tauxSatisfactionPct | number:'1.1-1' }} %</div>
        </div>
        <div class="kpi">
          <div class="kpi-label">Clients satisfaits (≥ 4★)</div>
          <div class="kpi-valeur">{{ nbSatisfaits }}</div>
        </div>
      </div>

      <div style="display:grid;grid-template-columns:1fr 1.4fr;gap:18px;">
        <div>
          <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:0 0 8px;">Distribution des notes</h4>
          <div echarts [options]="optDistribution" class="chart-container" style="height:260px"></div>
        </div>
        <div>
          <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:0 0 8px;">Évolution de la note moyenne</h4>
          <div echarts [options]="optEvolution" class="chart-container" style="height:260px"></div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- ── 2.2 Retours clients / enquêtes ────────────────── -->
  <div class="carte-rapport">
    <div class="carte-titre">
      <h3><i class="fal fa-comments"></i> Retours client &amp; enquêtes</h3>
      <span class="periode-info" *ngIf="retoursFiltres.length > 0">{{ retoursFiltres.length }} commentaire(s)</span>
    </div>

    <!-- Barre de filtres -->
    <div class="filtres-retours">
      <input type="text" placeholder="Rechercher un mot-clé (ex: retard)" [(ngModel)]="motCle"
             class="input-recherche" />

      <!-- Filtre étoiles visuel -->
      <div class="filtre-etoiles-wrap">
        <span class="filtre-etoiles-label">Filtrer par note max :</span>
        <div class="filtre-etoiles">
          <button *ngFor="let n of [1,2,3,4,5]"
                  class="etoile-btn"
                  [class.active]="etoileActive(n)"
                  (click)="selectionnerEtoile(n)"
                  [title]="'≤ ' + n + ' étoile' + (n > 1 ? 's' : '')">
            ★
          </button>
          <button *ngIf="noteMaxSelectionnee != null"
                  class="etoile-reset"
                  (click)="selectionnerEtoile(noteMaxSelectionnee!)"
                  title="Effacer le filtre">
            ✕
          </button>
        </div>
        <span *ngIf="noteMaxSelectionnee != null" class="filtre-etoiles-info">
          ≤ {{ noteMaxSelectionnee }} étoile{{ noteMaxSelectionnee > 1 ? 's' : '' }}
        </span>
      </div>

      <button (click)="recherchePersonnalisee()"
              class="btn-filtrer">
        <i class="fal fa-search"></i> Filtrer
      </button>
    </div>

    <!-- Aucun commentaire -->
    <div *ngIf="retoursFiltres.length === 0" class="vide">
      <i class="fal fa-inbox"></i>
      Aucun commentaire ne correspond aux critères sélectionnés.
    </div>

    <ng-container *ngIf="retoursFiltres.length > 0">
      <div style="display:grid;grid-template-columns:1.4fr 1fr;gap:18px;">
        <!-- Liste des commentaires -->
        <div>
          <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:0 0 8px;">Commentaires récents</h4>
          <div *ngFor="let c of retoursFiltres" class="commentaire-item">
            <div class="commentaire-header">
              <span class="commentaire-meta">
                <strong>{{ c.numeroCommande || '—' }}</strong> · {{ c.clientNom || 'Anonyme' }}
              </span>
              <span class="commentaire-note">
                <span class="badge-note" [ngClass]="classeNote(c.noteSatisfactionClient)">
                  {{ c.noteSatisfactionClient || 0 }}/5
                </span>
                <span class="etoiles-display">{{ etoiles(c.noteSatisfactionClient) }}</span>
                <span class="commentaire-date">{{ c.dateSatisfaction | date:'dd/MM/yy HH:mm' }}</span>
              </span>
            </div>
            <p class="commentaire-texte">{{ c.commentaireSatisfaction }}</p>
            <small class="commentaire-livreur">Livreur : {{ c.livreurNom || '—' }}</small>
          </div>
        </div>

        <!-- Répartition thématique -->
        <div>
          <h4 style="font-size:12px;color:#64748b;text-transform:uppercase;margin:0 0 8px;">Répartition thématique</h4>
          <div *ngIf="optThemes && $any(optThemes).series" echarts [options]="optThemes"
               class="chart-container" style="height:300px"></div>
          <div *ngIf="!$any(optThemes).series" class="vide" style="height:300px">
            <i class="fal fa-chart-pie"></i> Pas assez de données
          </div>
        </div>
      </div>
    </ng-container>
  </div>

</ng-container>
